package com.anjuros.website.templates.template9.modules

import com.anjuros.website.templates.template9.util.ResKey

enum class Template9FAQ(
    val question: ResKey,
    val answer: ResKey
) {
    FAQ1(question = ResKey.TEMPLATE9_FAQ1_Q, answer = ResKey.TEMPLATE9_FAQ1_A),
    FAQ2(question = ResKey.TEMPLATE9_FAQ2_Q, answer = ResKey.TEMPLATE9_FAQ2_A),
    FAQ3(question = ResKey.TEMPLATE9_FAQ3_Q, answer = ResKey.TEMPLATE9_FAQ3_A),
    FAQ4(question = ResKey.TEMPLATE9_FAQ4_Q, answer = ResKey.TEMPLATE9_FAQ4_A),
    FAQ5(question = ResKey.TEMPLATE9_FAQ5_Q, answer = ResKey.TEMPLATE9_FAQ5_A),
    FAQ6(question = ResKey.TEMPLATE9_FAQ6_Q, answer = ResKey.TEMPLATE9_FAQ6_A),
}
